import { Styled404 } from "./NotFound.styles"


function NotFound() {
  return (
    <Styled404>
      <h1>
        Page Not Found
      </h1>
    </Styled404>
  )
}

export default NotFound